import { render, staticRenderFns } from "./TranscriptionInWord.vue?vue&type=template&id=7b3d11ad&lang=pug&"
import script from "./TranscriptionInWord.vue?vue&type=script&lang=js&"
export * from "./TranscriptionInWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports